import { UpdateKeyValueRequest } from "@models/base/updateKeyValueRequest.model";

export class UpdateNotificacionRequest extends UpdateKeyValueRequest {
  idTipoNotificacion!: number;
  fechaEnvio!: string;
  estadoEntrega!: boolean;
  estadoLectura!: boolean;
  asunto!: string | null;
  contenido!: string | null;
  idTipoEntidad!: number | null;
  entidadId!: number | null;
}
